import styled, { css } from 'styled-components';
import Typography from '../../../../typography';
import { pxToRem } from '../../../../../design-tokens/style-utilities';
import { pickToken } from '../../../styles/helper';
const radioCheckboxGroupContainerStyles = ({ theme }) => css `
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	gap: ${pxToRem(theme.spacing['100'])};
`;
export const RadioCheckboxGroupContainer = styled.div `
	${radioCheckboxGroupContainerStyles}
`;
const radioCheckboxGroupItemsVerticalStyles = ({ theme }) => css `
	display: flex;
	flex-direction: column;
	gap: ${pxToRem(theme.spacing['300'])};
`;
export const RadioCheckboxGroupItemsVertical = styled.div `
	${radioCheckboxGroupItemsVerticalStyles}
`;
const radioCheckboxGroupItemsHorizontalStyles = ({ theme }) => css `
	display: flex;
	flex-wrap: wrap;
	gap: ${pxToRem(theme.spacing['400'])};
`;
export const RadioCheckboxGroupItemsHorizontal = styled.div `
	${radioCheckboxGroupItemsHorizontalStyles}
`;
const radioCheckboxGroupContainerFieldLabelStyles = ({ theme, $colorContext, }) => css `
	&&& {
		/* CORE-UI override */
		margin-top: 0;
	}

	color: ${pickToken({
    'on-light': theme.colors.base.textBody,
    'on-medium': theme.colors.base.textBody,
    'on-dark': theme.colors.blanc.textInverse,
}, $colorContext)};
`;
export const RadioCheckboxGroupContainerFieldLabel = styled(Typography).attrs({
    tagName: 'span',
    variant: 'label-title',
}) `
	${radioCheckboxGroupContainerFieldLabelStyles}
`;
const fieldsetContentStyles = ({ theme }) => css `
	display: flex;
	flex-direction: column;
	gap: ${pxToRem(theme.spacing['300'])};
`;
export const FieldsetContent = styled.div `
	${fieldsetContentStyles}
`;
